<template>
    <div>
        <public-menu></public-menu>
        <biyuntao-search></biyuntao-search>
        <bottom-nav></bottom-nav>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Biyuntao_search from "@/components/biyuntao/Index"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../components/Footer.vue"
export default{
    components:{
        'public-menu': Public_menu,
        'biyuntao-search':Biyuntao_search,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
</style>


// WEBPACK FOOTER //
// src/views/biyuntao/Index.vue